<template>
  <v-row
    class="welcome-block mx-auto"
    align="center"
    justify="center"
  >
    <v-col cols="auto">
      <h1 class="mb-4 text-center">Моніторинг транспортних засобів</h1>
      <div class="text-center">
        <slot />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'c-welcome-block'
}
</script>

<style lang="scss">
  .welcome-block {
    position: absolute;
    top: 0;
    left: 62px;
    width: calc(100% - 62px);
    height: 100%;
    min-height: 100vh;
    z-index: 2;
  }
</style>